import auth from '@/router/auth'
import services from '@/utils/services'
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

async function checkDepartureAuth(to, from, next) {
  const token = to.query.token
  if (!token) {
    NProgress.done()
    next('/login')
  }
  try {
    await axios.post(services.routes.clientDeparturesCheckAuth, { token })
  } catch (error) {
    NProgress.done()
    next('/login')
  }
  NProgress.done()
  next()
}

function checkSession(to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check().then((res) => {
      NProgress.done()
      if (res) {
        next()
      } else {
        next('/login')
      }
    })
  } else {
    NProgress.done()
    next('/login')
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: {
        path: '/404'
      }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('@/pages/errors/404.vue')
    },
    {
      path: '/403',
      name: 'AccessDenied',
      component: () => import(`@/pages/errors/403.vue`)
    },
    {
      path: '/privacyNotice',
      name: 'privacyNotice',
      component: () => import(`@/pages/privacyNotice.vue`)
    },
    {
      path: '/privacyNotice/:last',
      name: 'privacyNoticeLast',
      component: () => import(`@/pages/privacyNotice.vue`)
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(`@/pages/Login.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done()
            if (res) {
              next('/client/home')
            } else {
              next()
            }
          })
        } else {
          NProgress.done()
          next()
        }
      }
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: () => import(`@/pages/Forgot.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done()
            if (res) {
              next('/client/home')
            } else {
              next()
            }
          })
        } else {
          NProgress.done()
          next()
        }
      }
    },
    {
      path: '/reset/recovery',
      name: 'Recovery',
      component: () => import(`@/pages/reset/Recovery.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done()
            if (res) {
              next('/client/home')
            } else {
              next()
            }
          })
        } else {
          NProgress.done()
          next()
        }
      }
    },
    {
      path: '/reset/password',
      name: 'Password',
      component: () => import(`@/pages/reset/Password.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done()
            if (res) {
              next('/client/home')
            } else {
              next()
            }
          })
        } else {
          NProgress.done()
          next()
        }
      }
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: () => import(`@/pages/reset/Redirect.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done()
            if (res) {
              next('/client/home')
            } else {
              next()
            }
          })
        } else {
          NProgress.done()
          next()
        }
      }
    },
    {
      path: '/',
      name: 'Root',
      redirect: {
        name: 'Login'
      },
      component: () => import(`@/pages/client/Root.vue`),
      children: [
        {
          path: '/client/home',
          name: 'Home',
          component: () => import(`@/pages/client/Home.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/reporteUsuarios',
          name: 'ReporteUsuarios',
          component: () => import(`@/pages/client/reports/usersReport.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/EmpleadosYRutas',
          name: 'EmpleadosYRutas',
          component: () => import(`@/pages/client/employeeCompany/employeeRoutes.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/administracionEmpleados/:idCliente/:idEmpleado',
          name: 'EmpleadosYRutasDetalle',
          component: () => import(`@/pages/client/employeeCompany/employeeAdmin.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/nuevoEmpleado/:idCliente',
          name: 'nuevoEmpleado',
          component: () => import(`@/pages/client/employeeCompany/employeeAdmin.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/administracionPasajerosYViajes',
          name: 'adminViajes',
          component: () => import(`@/pages/client/employeeCompany/userTravel.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/reporteDeNoAcceso',
          name: 'accessReport',
          component: () => import(`@/pages/client/employeeCompany/noAccessReport.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/konectVan/viajes',
          name: 'konectVan',
          component: () => import(`@/pages/konectVan.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/ascensos',
          name: 'ascensos',
          component: () => import(`@/pages/konectAsc.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/reporteRegioRuta',
          name: 'reportRegioRuta',
          component: () => import(`@/pages/konectRegRt.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/reporteRegioRutaExtendido',
          name: 'reportRegioRutaExtendido',
          component: () => import(`@/pages/konectRegRtExt.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/conciliacionRegioRuta',
          name: 'conciliacionRegioRuta',
          component: () => import(`@/pages/konectRegRtConciliacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/mapaRegioRuta',
          name: 'mapaRegioRuta',
          component: () => import(`@/pages/mapaOpRegRt.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/konectVan/VanOffline',
          name: 'EmpleadosVanOffline',
          component: () => import(`@/pages/vanOffline.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/konectVan/mapa',
          name: 'konectVanMap',
          component: () => import(`@/components/konectVan/Map.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/departures',
          name: 'clientDepartures',
          component: () => import(`@/components/exits/Dashboard.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/client/departures/auth',
          name: 'clientDeparturesAuth',
          component: () => import(`@/components/exits/Dashboard.vue`),
          beforeEnter: checkDepartureAuth
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
